import React from "react";
import Alert, { ALERT_SUCCESS } from "./Alert";
import useErrors from "./errors/useErrors";
import useSuccessMessage from "./success/useSuccessMessage";
import Error from "./errors/Error";

export default function Alerts() {
	const { errors } = useErrors();
	const { success, onRemoveSuccessMessage } = useSuccessMessage();

	let errorsAlert: React.ReactNode;
	let successAlert: React.ReactNode;

	if (errors && Object.keys(errors).length > 0) {
		errorsAlert = <Error errors={errors} />;
	}

	if (success) {
		successAlert = (
			<Alert severity={ALERT_SUCCESS} onClose={onRemoveSuccessMessage}>
				<p>{success}</p>
			</Alert>
		);
	}

	return (
		<>
			{successAlert}
			{errorsAlert}
		</>
	);
}
